import React from "react";

export default function SettingsLayout({ Sidebar, title = "Settings", children }) {
  return (
    <div className="flex min-h-screen bg-gray-100 dark:bg-gray-900">
      {Sidebar ? <Sidebar /> : null}

      <main className="flex-1 p-6 space-y-6">
        <div className="flex justify-between items-center bg-gradient-to-r from-green-700 to-green-500 text-white p-5 rounded-xl shadow-md">
          <h2 className="text-2xl font-bold">{title}</h2>
        </div>

        {children}
      </main>
    </div>
  );
}
